import { GridApi } from "@ag-grid-community/core";
import {
  CdkPortalOutletAttachedRef,
  ComponentPortal,
} from "@angular/cdk/portal";
import { Component, ComponentRef, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { GridApiService } from "src/app/data-grid/grid-api.service";
import { LoginModel } from "src/app/models/login.model";
import { PriceyardService } from "src/app/modules/priceyard/services/priceyard.service";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { AuthService } from "src/app/services/auth.service";
import { SkuDetail } from "./../../models/priceyard.model";
import { PlanyardPanelComponent } from "./planyard-panel/planyard-panel.component";
import { PriceyardPanelComponent } from "./priceyard-panel/priceyard-panel.component";
import { ShipyardPanelComponent } from "./shipyard-panel/shipyard-panel.component";
import { InventoryService } from "src/app/services/inventory.service";
import { CreateTagDialogComponent } from "src/app/modules/settings/create-tag-dialog/create-tag-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { ConfirmDialogComponent } from "src/app/components/dialogs/confirm-dialog/confirm-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
@Component({
  selector: "app-sku-tool-panel",
  templateUrl: "./sku-tool-panel.component.html",
  styleUrls: ["./sku-tool-panel.component.scss"],
})
export class SkuToolPanelComponent implements OnDestroy {
  gridApi: GridApi;
  selectedItem;
  competitors;
  loading:boolean=false;
  history;
  selectedSku: SkuDetail;
  userInfo: LoginModel;
  selectedPortal;
  private destroy$ = new Subject<void>();
  private rowChanged$:BehaviorSubject<boolean> = new BehaviorSubject(true);
  selectedRow;
  portals = {
    inventory: new ComponentPortal(ShipyardPanelComponent),
    forecasting: new ComponentPortal(PlanyardPanelComponent),
    shipyard: new ComponentPortal(PlanyardPanelComponent),
    priceyard: new ComponentPortal(PriceyardPanelComponent),
  };

  private _editPortal: any;
  isModel= false;
  selectedMarkupType: any[] = [];

  get editPortal(): any {
    return this._editPortal;
  }

  set editPortal(editPortal: any) {
    this._editPortal = editPortal;
  }
  editId: number;
  editTitle: number;
  mappings;
  routeName:string;
  allTags:any[]=[];
  skuTagsDto:any[]=[];

  constructor(
    public gridActionsService: GridActionsService,
    private priceyardService: PriceyardService,
    private gridApiService: GridApiService,
    public shipyardService: ShipyardService,
    public router: Router,
    private authService: AuthService,
    private inventoryService: InventoryService,
    private dialog : MatDialog,
    private snackBar: MatSnackBar
  ) {}

  agInit(params: any): void {
    this.gridApi = params.api;
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => (this.userInfo = res));
      this.selectedRow = this.gridApi.getSelectedRows();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  refresh() {
    this.allTags = [];
    this.selectedRow = this.gridApi.getSelectedRows();
    this.isModel = this.selectedRow?.findIndex((res) => res?.isModel) !== -1;
    this.editPortal=undefined
    if (this.selectedRow.length === 1) {
      this.getSkuDetails(this.selectedRow[0]);
    } else if (this.selectedRow.length === 0) this.selectedSku = undefined;
  }

  setSidepanelContent() {
    this.routeName = this.router.url.split("/").filter((e) => e)[0];
    this.selectedPortal = this.portals[this.routeName];
  }

  attach(ref: CdkPortalOutletAttachedRef) {
    ref = ref as ComponentRef<any>;
    this.rowChanged$
    .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        ref = ref as ComponentRef<any>;
        ref.instance.selectedSku = this.selectedSku;
        ref.instance.routeName = this.routeName;
        ref.instance.selectedRow = this.selectedRow;
        ref.instance.selectedMarkupType = this.selectedMarkupType;
      });

    if (ref.instance.refresh) {
      ref.instance.refresh.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.getSkuDetails({
          Sku: this.selectedSku.accountSkuId,
          Account: this.selectedSku.account,
          FulfillmentType: this.selectedSku.fulfillmentType,
        });
      });
    }

    if (ref.instance.editEvent) {
      ref = ref as ComponentRef<any>;
      ref.instance.editEvent.pipe(takeUntil(this.destroy$)).subscribe((event) => {
        this.editPortal = new ComponentPortal(event.component);
        this.editTitle = event.title;
        this.editId = event.id;
        this.mappings=event.mappings;
      });
    }
  }

  attachEditPortal(ref: CdkPortalOutletAttachedRef) {
    ref = ref as ComponentRef<any>;
    ref.instance.sku = this.selectedSku;
    ref.instance.mappings=this.mappings;
    ref.instance.selectedMarkupType = this.selectedMarkupType;

    if (ref.instance.viewEvent) {
      ref.instance.viewEvent.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.editPortal = undefined;
      });
    }
  }

  getSkuCompetition(asin) {
    this.priceyardService.SkuCompetition(asin).pipe(takeUntil(this.destroy$)).subscribe((response) => {
      this.competitors = response;
    });
  }

  getRepriceHistory(sku, account) {
    this.priceyardService
      .SkuRepriceHistory(sku, account).pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.history = response;
      });
  }

  getSkuDetails(selectedItem,isRefresh:boolean = false): void {
      this.loading=true;
        this.getTags();
      this.selectedItem = selectedItem;
      this.priceyardService
          .getSkuDetails(
              selectedItem.AccountSkuId,
              selectedItem.Account,
              selectedItem.FulfillmentType
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe((response: SkuDetail) => {
              this.loading=false;
              this.selectedSku = response;
              this.selectedMarkupType = [];
              let idx = this.selectedSku.priceBreakdown.findIndex((res)=> res.name === 'Markup Type');
              if(idx !== -1) this.selectedMarkupType.push(...this.selectedSku.priceBreakdown.splice(idx, 1));
              if(this.selectedSku.getSkuTagsDto){
                this.skuTagsDto = this.selectedSku.getSkuTagsDto;
                this.allTags.forEach((res,i) => {
                  let index = this.skuTagsDto.findIndex((el) => el.tagId == res.tagId);
                   if (index !== -1) this.allTags[i].hide = true;      
                  })
                  this.allTags = this.allTags.filter((res)=> !res?.hide);
              }
              this.selectedSku.image = this.selectedSku.image ? this.selectedSku.image : "assets/images/No_image.png";
              this.setSidepanelContent();
              this.rowChanged$.next(true);
          })
              // this.setSidepanelContent();
    
  }

  getTags() {
    this.inventoryService.GetTags().pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
          if (data) {
            this.allTags = data;
          }
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        });
       }
      })
  }

  openAllTag(e: MouseEvent) {
    this.dialog.open(CreateTagDialogComponent, {
      backdropClass: "cdk-overlay-transparent-backdrop",
      position: this.getDialogRightPosition(e),
      data: {
        tag: this.allTags,
        title: "Add Tags in Sku",
        isSkuTag: true,
        isTags: true,
        accountSkuId: this.selectedItem.AccountSkuId
      }
    }).afterClosed()
      .pipe(filter((res) => res === "save"))
      .subscribe({
        next: () => {
          this.shipyardService.isTagAdded = true;
          this.gridApi.refreshServerSide({ route: [], purge: true });
          this.getSkuDetails(this.selectedRow[0], true);
        },
      });
  }

  getDialogRightPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      bottom: targetPosision + 500 + "px",
      left: this.skuTagsDto.length>=4 ? targetPosision.left - 100 + "px" : targetPosision.left + "px", 
      right: targetPosision.right + 150 + "px",
      top: targetPosision.top + 22 + "px",
    };
  }

  deleteTag(tagId) {
    let payload = {
      accountSkuId: this.selectedItem.AccountSkuId,
      tagId: [tagId]
    }
    this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Delete Tag",
        message: "Are you sure you want to delete this Tag?",
      },
    }).afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe(() => {
        this.inventoryService.DeleteTagInSku(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (data) => {
            this.shipyardService.isTagAdded = true;
            this.gridApi.refreshServerSide({ route: [], purge: true });
            this.getSkuDetails(this.selectedRow[0], true);
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Tag deleted successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            );
          },
        });
      });
  }
}
